'use client';

import { AUTH_SWITCH_COOKIE } from './constants/auth-switch-cookie';

/**
 * Clear auth switch cookie (client-side)
 */
export function clearAuthSwitchCookie(): void {
  document.cookie = `${AUTH_SWITCH_COOKIE}=; path=/; max-age=0`;
}
